module.exports = __webpack_public_path__ + "static/media/roads&highways.5885261c.png";